<template>
  <!-- 品牌&关键词 -->
  <div class="account_manage">
    <keyword-search
      ref="searchBox"
      class="search_box"
      :enterpriseList="enterpriseList"
      @search-change="changeSearch"
      @add-keyword="add"
    >
    </keyword-search>
    <keyword-table
      class="search_table"
      :loading="loading"
      :keywordList="keywordList"
      :params="tableParams"
      @change-page="changePage"
      @update="getBrandList"
      @edit-keyword="editBrand"
    >
    </keyword-table>
    <keyword-modal
      :visible="ifModal"
      :edit="edit"
      :initFormData="currentData"
      :enterpriseList="enterpriseList"
      @close-modal="ifModal = false"
      @update="getBrandList"
    >
    </keyword-modal>
  </div>
</template>

<script>
import keywordSearch from "./keywordSearch.vue";
import keywordTable from "./keywordTable.vue";
import keywordModal from "./keywordModal.vue";
import { get } from "lodash";

export default {
  name: "AccountManage",
  components: {
    keywordSearch,
    keywordTable,
    keywordModal,
  },
  data() {
    return {
      keywordList: [], //品牌&关键词列表

      tableParams: {
        // 分页器的参数
        total: 0,
        page: 1,
        size: 10,
      },
      loading: false,
      ifModal: false, // 是否展示modal
      edit: false, // 当前弹窗状态是编辑还是添加
      currentData: {}, // 当前编辑所选的数据

      enterpriseList: [], // 企业列表数据
    };
  },
  computed: {},
  mounted() {
    this.getEnterprise();
    this.getBrandList();
  },
  methods: {
    // 获取企业列表
    getEnterprise() {
      this.$http({
        url: "/enterprise/listEnterName",
        method: "get",
      })
        .then((res) => {
          if (res.code === 200) {
            this.enterpriseList = res.data;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "获取企业列表接口请求失败",
            type: "error",
          });
        });
    },
    // 获取品牌&&关键词列表
    getBrandList(val) {
      this.loading = true;

      const data = {
        page: this.tableParams.page,
        size: this.tableParams.size,
        body: val || this.$refs.searchBox.computeSearch,
      };
      this.$http({
        url: "/brandKey/listPage",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res && res.code === 200) {
            const newList = get(res, "data.list", []);
            this.keywordList = [];
            this.keywordList =
              newList &&
              newList.map((item) => ({
                ...item,
                otherBrandLogo: item.brandLogo
                  ? item.brandLogo.replace(
                      "http://gov.eagle.datastory.com.cn",
                      "https://soujian.datatell.com.cn"
                    )
                  : "",
              }));
            this.tableParams.total = get(res, "data.total", 0);
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: "获取企业列表接口请求失败",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 搜索更新
    changeSearch(val) {
      this.tableParams.page = 1;
      this.getBrandList(val);
    },
    changePage(page) {
      this.tableParams.page = page;
      this.getBrandList();
    },
    // 点击弹窗弹出添加
    add() {
      this.edit = false;
      this.ifModal = true;
    },
    // 点击弹窗弹出编辑
    editBrand(row) {
      this.currentData = row;
      this.edit = true;
      this.ifModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.account_manage {
  height: 100%;
  display: flex;
  flex-direction: column;
  .search_table {
    flex: 1;
    height: 0;
  }
}

// .form {
//   width: 668px;
//   flex-shrink: 0;
// }
// $logo-size: 32px;
// .logo {
//   width: $logo-size;
//   height: $logo-size;
// }
</style>




// WEBPACK FOOTER //
// src/pages/index/views/brandWord/index.vue